import RadioSymbol from 'components/elements/symbols/RadioSymbol'
import Text from 'components/elements/texts/Text'
import React from 'react'
import styled from 'styled-components'
import ItemLine from './ItemLine'
import DatePicker from './DatePicker'
import { EditingItemContext } from 'contexts/EditingItemContext'
import { TroubleDatetimeTypes } from 'states/QnState'
import { VEHICLE_STATE_FORM_EARLIER_MINTIME } from 'constants/qnState'
import dayjs from 'dayjs'
import { useLocation } from 'react-router-dom'
import { PAGE_PATH } from 'constants/pagePath'

/**
 * 対象がRadioLineProps型かチェックする
 * @param target チェック対象
 */
export const isRadioLineProps = (target: any): target is RadioLineProps => {
  return target.isSelected !== undefined && target.label !== undefined
}

/**
 * 選択肢のラジオ行
 * ※「上記以外」選択時は日付入力ボックスを表示する
 */
const RadioLine: React.FC<RadioLineProps> = (props) => {
  const [editingItem, setEditingItem] = React.useContext(EditingItemContext)

  /** 上記以前 デフォルト日時 */
  const defaltDate = dayjs().subtract(1, 'day').format('YYYY/MM/DD:09')

  const minDate = VEHICLE_STATE_FORM_EARLIER_MINTIME

  /** トラブル発生日時を切り替えたときのイベント */
  const handleDateChanged = React.useCallback(
    (time: string): void => {
      setEditingItem({
        ...editingItem,
        troubleDatetime: {
          timing: editingItem.troubleDatetime.timing,
          date: time,
        },
      })
    },
    [setEditingItem]
  )

  /** 表示画面パス取得 */
  const pathname = useLocation().pathname

  return (
    <ItemLine onClick={props.onClick} showLineBorder lineOffset="54px">
      <SymbolArea>
        <RadioSymbol height="24px" width="24px" isSelected={props.isSelected} />
      </SymbolArea>
      <TextAreaWrap>
        <TextArea>
          <Text>
            {props.label.indexOf('上記以前') > -1 ? '上記以前' : props.label}
          </Text>
        </TextArea>
        {editingItem.troubleDatetime.timing ===
          TroubleDatetimeTypes.earlier.datetypes &&
        props.isSelected &&
        pathname === PAGE_PATH.VEHICLE_STATE ? (
          <TimePickerArea>
            <DatePicker
              time={
                editingItem.troubleDatetime.date === ''
                  ? defaltDate
                  : editingItem.troubleDatetime.date
              }
              minTime={minDate}
              onChanged={handleDateChanged}
            />
          </TimePickerArea>
        ) : (
          false
        )}
      </TextAreaWrap>
    </ItemLine>
  )
}

export type RadioLineProps = {
  isSelected: boolean
  label: string
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

const SymbolArea = styled.div`
  height: 24px;
  margin-right: 12px;
  margin-left: 18px;
`

const TextArea = styled.div`
  flex: 1;
`

const TimePickerArea = styled.div`
  display: flex;
  width: 60%;
  align-items: center;
`
const TextAreaWrap = styled.div`
  display: flex;
  flex-direction: column;
`

export default RadioLine
